{
  "name": "backoffice",
  "version": "3.14.1",
  "type": "module",
  "scripts": {
    "ng": "ng",
    "start": "concurrently \"ng serve\" \"npm run lint:watch\"",
    "build": "ng build",
    "lint": "eslint .",
    "lint:watch": "chokidar \"src/**/*.ts\" -c \"npm run lint -- --no-cache\"",
    "build:prod": "ng build --configuration production",
    "build:dev": "ng build --configuration development",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "feature": "ng generate ./schematics:feature",
    "postversion": "git push --follow-tags",
    "deploy": "npm run build:prod && firebase deploy --only hosting:prod",
    "deploy:prod": "npm run build:prod && firebase deploy --only hosting:prod",
    "deploy:dev": "npm run build:dev && firebase deploy --only hosting:dev --project excuela-dev",
    "deploy:hosting:prod": "firebase deploy --only hosting:prod",
    "deploy:hosting:dev": "firebase deploy --only hosting:dev",
    "prepare": "husky"
  },
  "lint-staged": {
    "src/**/*.ts": "eslint --fix --max-warnings=0"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.1.3",
    "@angular/common": "^21.1.3",
    "@angular/compiler": "^21.1.3",
    "@angular/core": "^21.1.3",
    "@angular/fire": "^20.0.1",
    "@angular/forms": "^21.1.3",
    "@angular/platform-browser": "^21.1.3",
    "@angular/platform-browser-dynamic": "^21.1.3",
    "@angular/router": "^21.1.3",
    "@fortawesome/fontawesome-free": "^6.7.2",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@primeng/themes": "^20.0.1",
    "@types/firebase": "^2.4.32",
    "angularx-qrcode": "^20.0.0",
    "echarts": "^6.0.0",
    "eslint": "^9.39.4",
    "firebase": "^11.6.1",
    "google-libphonenumber": "^3.2.44",
    "konva": "^10.4.0",
    "ngx-dynamic-skeleton": "^0.2.1",
    "ngx-echarts": "^20.0.2",
    "pdfmake": "^0.2.20",
    "primeflex": "^4.0.0",
    "primeicons": "^7.0.0",
    "primeng": "^20.0.1",
    "quill": "^2.0.3",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/core": "^21.1.3",
    "@angular/build": "^21.1.3",
    "@angular/cli": "^21.1.3",
    "@angular/compiler-cli": "^21.1.3",
    "@types/google-libphonenumber": "^7.4.30",
    "@types/jasmine": "~5.1.0",
    "@types/pdfmake": "^0.2.12",
    "@typescript-eslint/eslint-plugin": "^8.42.0",
    "@typescript-eslint/parser": "^8.42.0",
    "chokidar-cli": "^3.0.0",
    "concurrently": "^9.2.1",
    "eslint-plugin-unused-imports": "^4.2.0",
    "husky": "^9.1.7",
    "jasmine-core": "~5.2.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "lint-staged": "^16.4.0",
    "typescript": "~5.9.3"
  }
}
